import { createSlice } from '@reduxjs/toolkit';
import { addNewInterest, editInterest, getAllInterests } from './interestService';

const initialState = {
  allInterests: {
    isInterestsLoading: null,
    isInterestsSuccess: null,
    interestsMessage: null,
    pageCount: 0,
    interests: [],
  },
  newInterest: {
    isInterestCreating: null,
    isInterestCreated: null,
    interestCreationMsg: null,
  },

  editedInterest: {
    isEditingInterest: null,
    isInterestEdited: null,
    interestEditedMsg: null
  }
};

const interestsSlice = createSlice({
  name: 'interest',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllInterests.pending, (state) => {
        state.allInterests = {
          ...initialState.allInterests, // Reset to initial state
          isInterestsLoading: true,
          interestsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllInterests.rejected, (state, action) => {
        state.allInterests = {
          ...initialState.allInterests,
          isInterestsLoading: false,
          isInterestsSuccess: false,
          interestsMessage: action.payload || 'Error occurred while fetching interests',
        };
      })

      // FULFILLED
      .addCase(getAllInterests.fulfilled, (state, action) => {
        state.allInterests = {
          ...initialState.allInterests,
          isInterestsLoading: false,
          isInterestsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          interests: action.payload || [],
        };
      });

    //Interest creating
    builder
      .addCase(addNewInterest.pending, (state) => {
        state.newInterest = {
          ...initialState.newInterest, // Reset to initial state
          isInterestCreating: true,
          interestCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewInterest.rejected, (state, action) => {
        state.newInterest = {
          ...initialState.newInterest,
          isInterestCreating: false,
          isInterestCreated: false,
          interestCreationMsg: action.payload || 'Error occurred while creating the interest.',
        };
      })

      // FULFILLED
      .addCase(addNewInterest.fulfilled, (state, action) => {
        state.newInterest = {
          ...initialState.newInterest,
          isInterestCreating: false,
          isInterestCreated: true,
          interestCreationMsg: action.payload || 'Successfully created the interest.',
        };
      });

    //Interest editing
    builder
      .addCase(editInterest.pending, (state) => {
        state.editedInterest = {
          ...initialState.editedInterest, // Reset to initial state
          isEditingInterest: true,
          interestEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editInterest.rejected, (state, action) => {
        state.editedInterest = {
          ...initialState.editedInterest, // Reset to initial state
          isEditingInterest: false,
          isInterestEdited: false,
          interestEditedMsg: action.payload || 'Error occurred while editing the interest.',
        };
      })

      // FULFILLED
      .addCase(editInterest.fulfilled, (state, action) => {
        state.editedInterest = {
          ...initialState.editedInterest, // Reset to initial state
          isEditingInterest: false,
          isInterestEdited: true,
          interestEditedMsg: action.payload || 'Successfully edited the interest.',
        };
      });
  },
});

export default interestsSlice.reducer;
